if (!customElements.get('ug-product-buy')) {
  customElements.define('ug-product-buy', class extends HTMLElement {
    connectedCallback() {
      this.scope = this.closest('product-info');
      this.productForm = this.scope?.querySelector('product-form');
      this.button = this.productForm?.querySelector('[name="add"]');
      if (!this.button) return;
      this.label = this.button.querySelector('span');
      this.originalLabel = this.label.textContent.trim();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      const icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      icon.setAttribute('viewBox', '0 0 24 24');
      icon.setAttribute('class', 'ug-buy-icon');
      icon.setAttribute('aria-hidden', 'true');
      icon.innerHTML = '<path d="M5 7h14l1 14H4L5 7Z"/><path d="M8 8V6a4 4 0 0 1 8 0v2"/>';
      this.button.append(icon);
      this.icon = icon;
      this.note = document.createElement('p');
      this.note.className = 'ug-buy-note';
      this.note.textContent = this.dataset.assurance;
      this.productForm.after(this.note);
      this.bar = this.querySelector('.ug-buy-sticky');
      this.barButton = this.bar.querySelector('button');
      this.price = this.bar.querySelector('.ug-buy-sticky__price');
      this.variant = this.bar.querySelector('small');
      this.status = this.querySelector('[role="status"]');
      this.scope.addEventListener('click', (event) => {
        const mini = event.target.closest('[data-ug-mini-buy]');
        const main = event.target.closest('[name="add"]');
        if ((!mini || !this.scope.contains(mini)) && main !== this.button) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (this.button.disabled || this.button.getAttribute('aria-disabled') === 'true') return;
        if (typeof this.productForm.onSubmitHandler !== 'function') {
          this.status.textContent = 'Obrazac se učitava. Pokušaj ponovo za trenutak.';
          return;
        }
        this.productForm.dataset.ugMiniIntent = mini ? 'true' : 'false';
        // Call the AJAX handler directly, avoiding third-party synthetic-click hooks.
        this.productForm.onSubmitHandler(event);
      }, { ...options, capture: true });
      this.barButton.addEventListener('click', () => {
        if (!this.button.disabled && this.button.getAttribute('aria-disabled') !== 'true') this.button.click();
      }, options);
      this.productForm.addEventListener('submit', (event) => {
        const picker = this.scope.querySelector('variant-selects');
        const groups = picker ? [...picker.querySelectorAll('fieldset[data-ug-size-option]')] : [];
        const missing = groups.find(g => !g.querySelector('input:checked')) || (picker && [...picker.querySelectorAll('select')].find(s => !s.value));
        if (!missing) return;
        delete this.productForm.dataset.ugMiniIntent;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.label.textContent = this.dataset.choose;
        this.status.textContent = this.dataset.choose;
        this.sync();
        missing.scrollIntoView({ block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        missing.classList.add('ug-size-attention');
        missing.querySelector('input,select')?.focus({ preventScroll: true });
        setTimeout(() => missing.classList.remove('ug-size-attention'), 1600);
      }, { ...options, capture: true });
      this.scope.addEventListener('change', () => { clearTimeout(this.timer); this.succeeded = false; this.button.classList.remove('ug-added'); this.barButton?.classList.remove('ug-added'); }, options);
      this.productForm.addEventListener('ug:cart-state', (event) => {
        const state = event.detail;
        if (state === 'loading') {
          clearTimeout(this.timer);
          this.originalLabel = this.label.textContent.trim();
          this.succeeded = false;
          this.button.classList.remove('ug-added');
          this.barButton.classList.remove('ug-added');
          this.label.textContent = this.dataset.loading;
          this.button.setAttribute('aria-busy', 'true');
        } else if (state === 'success') {
          this.succeeded = true;
          this.label.textContent = this.dataset.added;
          this.status.textContent = this.dataset.added;
          this.button.classList.add('ug-added');
          this.barButton.classList.add('ug-added');
          const bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');
          if (bubble && !matchMedia('(prefers-reduced-motion: reduce)').matches) bubble.animate([{transform:'scale(1)'},{transform:'scale(1.2)'},{transform:'scale(1)'}],{duration:240});
        } else if (state === 'complete') {
          this.button.removeAttribute('aria-busy');
          if (this.succeeded) this.timer = setTimeout(() => {
            if (!this.button.disabled && this.label.textContent === this.dataset.added) this.label.textContent = this.originalLabel;
          this.button.classList.remove('ug-added'); this.barButton.classList.remove('ug-added');
          }, 1800);
          else if (this.label.textContent === this.dataset.loading) this.label.textContent = this.originalLabel;
        }
        this.sync();
      }, options);
      this.observer = new MutationObserver(() => this.sync());
      this.observer.observe(this.button, { attributes: true, childList: true, subtree: true, characterData: true });
      const priceNode = this.scope.querySelector('[id^="price-"]');
      if (priceNode) this.observer.observe(priceNode, { childList: true, subtree: true, characterData: true });
      this.intersection = new IntersectionObserver(() => this.updateVisibility());
      this.intersection.observe(this.button);
      this.media = matchMedia('(max-width: 749px)');
      this.media.addEventListener('change', () => this.updateVisibility(), options);
      window.addEventListener('scroll', () => this.updateVisibility(), { ...options, passive: true });
      this.sync();
    }
    sync() {
      if (!this.button?.isConnected) return;
      if (!this.button.disabled && this.button.getAttribute('aria-busy') !== 'true' && !this.succeeded && this.label.textContent !== 'Poruči sada') this.label.textContent = 'Poruči sada';
      const label = this.label.textContent.trim();
      if (this.barButton.textContent !== label) this.barButton.textContent = label;
      this.barButton.disabled = this.button.disabled || this.button.getAttribute('aria-disabled') === 'true';
      const priceBox = this.scope.querySelector('[id^="price-"]');
      const priceNode = priceBox?.querySelector('.price--on-sale .price-item--sale') || priceBox?.querySelector('.price__regular .price-item--regular');
      const value = priceNode?.textContent.trim() || '';
      if (this.price.textContent !== value) this.price.textContent = value;
      const picker = this.scope.querySelector('variant-selects');
      const selected = picker ? [...picker.querySelectorAll('input:checked,select')].map(el => el.value).join(' / ') : '';
      if (this.variant.textContent !== selected) this.variant.textContent = selected;
      this.scope.querySelectorAll('[data-ug-mini-buy]').forEach(mini => {
        mini.disabled = this.barButton.disabled;
        const text = mini.querySelector('span');
        const miniLabel = this.button.disabled ? label : 'Dodaj u korpu';
        if (text && text.textContent !== miniLabel) text.textContent = miniLabel;
        mini.classList.toggle('ug-added', this.button.classList.contains('ug-added'));
        if (this.button.getAttribute('aria-busy') === 'true') mini.setAttribute('aria-busy', 'true');
        else mini.removeAttribute('aria-busy');
      });
      this.updateVisibility();
    }
    updateVisibility() {
      if (this.bar) this.bar.hidden = !this.media?.matches || this.button.getBoundingClientRect().bottom > 0;
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      this.intersection?.disconnect();
      this.note?.remove();
      this.icon?.remove();
      clearTimeout(this.timer);
    }
  });
}

